import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="8" fill="url(#logo-gradient)"/>
    <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize="20" fontFamily="Outfit, sans-serif" fontWeight="bold">
      DC
    </text>
    <defs>
      <linearGradient id="logo-gradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#4f46e5" />
        <stop offset="100%" stopColor="#d946ef" />
      </linearGradient>
    </defs>
  </svg>
);

const Header = () => {
  return (
    <header className="py-6 px-8 flex justify-between items-center border-b border-brand-gray">
      <Link to="/" className="flex items-center space-x-4">
        <Logo />
        <span className="text-xl font-bold">DC Consulting</span>
      </Link>
      <nav className="hidden md:flex items-center space-x-8">
        <Link to="/services" className="hover:text-brand-primary transition-colors">Services</Link>
        <Link to="/about" className="hover:text-brand-primary transition-colors">About</Link>
        <Link to="/contact" className="hover:text-brand-primary transition-colors">Contact</Link>
      </nav>
      <Link to="/contact">
        <button className="bg-brand-primary hover:bg-opacity-80 text-white font-bold py-2 px-6 rounded-lg transition-colors">
          Get In Touch
        </button>
      </Link>
    </header>
  );
};

export default Header; 